import swal from "sweetalert";
import {InitPage} from "../index";

class CdmIndex {
    constructor() {
        $("#rrd_store_id").on("change", function (e) {
            e.preventDefault();
            const option_element = "option[value=" + $("#rrd_store_id").val() + "]";

            if ($("#rrd_store_id").val() === "Not Linked") {
                $("#selected_rrd_info").html("");
            } else {
                const rrd_info = $(option_element).data("rrd-info");
                if (typeof rrd_info === "undefined" ) {
                    $("#selected_rrd_info").html("");
                } else {
                    $("#selected_rrd_info").html(rrd_info);
                }
            }
        });

        $(".health_data").change(function(){
            const _anchor = this;
            let rrd = $(this).val();
            let check = $(this).is(":checked");
            let path = $(this).attr("data-path");
            $.post(path, { rrd: rrd, checked: check });
        });

        $("#checkAll").change(function () {
            if ($("#checkAll").prop("checked")) {
                $(".selectable").prop("checked", true);
            } else {
                $(".selectable").prop("checked", false);
            }
        });

        $("#buld_delete").click(function (e) {
            e.preventDefault();
            $("#loginModal").modal("show")
            e.stopPropagation();
            $("#loginForm").submit(function(ef) {
                ef.preventDefault()
                $.ajax({
                    method: "post",
                    dataType: "json",
                    url: "/users/confirm_super_user",
                    data: { password: $("#password").val() },
                    success: function(result) {
                        if (result.status == true) {
                            $("#loginModal").modal("hide")
                            let rrd_ids = [];
                            swal({
                                title: "Are you sure?",
                                text:  "This operation will delete the row",
                                icon: "warning",
                                closeOnClickOutside: false,
                                buttons: {
                                    cancel: {
                                    text: "No",
                                    value: null,
                                    visible: true,
                                    className: "sn-btn sn-btn-sm sn-btn-silver",
                                    closeModal: true
                                    },
                                    confirm: {
                                    text: "Yes",
                                    value: true,
                                    visible: true,
                                    className: "sn-btn sn-btn-sm sn-btn-red",
                                    closeModal: true
                                    }
                                },
                                dangerMode: true,
                                }).then((willDelete) => {
                                if (willDelete) {
                                    $(".selectable:checked").each(function () {
                                    console.log($(this).val());
                                    rrd_ids.push($(this).val())
                                    });
                                    let url = $("#buld_delete").data("url");
                                    $.ajax({
                                    url: url,
                                    data: {rrd_ids: rrd_ids},
                                    method: "DELETE",
                                    }).done(function (data) {
                                    location.reload();
                                    }).fail(function (data) {
                                    location.reload();
                                    });
                                }
                                });
                        } else {
                            alert("Authentication Failed")
                        }
                    }

                })
            })

        });

        $(".deleteCDM").on("click",function(e){
            const _anchor = this;
            e.preventDefault()
            $("#loginModal").modal("show")
            e.stopPropagation()
            $("#loginForm").submit(function(ef) {
                ef.preventDefault()
                $.ajax({
                    method: "post",
                    dataType: "json",
                    url: "/users/confirm_super_user",
                    data: { password: $("#password").val() },
                    success: function(result) {
                        if (result.status == true) {
                            $("#loginModal").modal("hide")
                            swal({
                                title: "Are you sure?",
                                text:  "This operation will delete the row",
                                icon: "warning",
                                closeOnClickOutside: false,
                                buttons: {
                                  cancel: {
                                    text: "No",
                                    value: null,
                                    visible: true,
                                    className: "sn-btn sn-btn-sm sn-btn-silver",
                                    closeModal: true
                                  },
                                  confirm: {
                                    text: "Yes",
                                    value: true,
                                    visible: true,
                                    className: "sn-btn sn-btn-sm sn-btn-red",
                                    closeModal: true
                                  }
                                },
                                dangerMode: true,
                              }).then((willDelete) => {
                                if (willDelete) {
                                  let url = $(_anchor).data("delete-path");
                                  $.ajax({
                                    url: url,
                                    method: "DELETE",
                                  });
                                }
                              });
                        } else {
                            alert("Authentication Failed")
                        }
                    }
                })
            })
        });

        $("#relink").on("click", function (e) {
            e.preventDefault();
            const rrd_info = $("#selected_rrd_info")[0];
            if (typeof rrd_info !== "undefined" && rrd_info.innerText !== "" ) {
                if ($("#rrd_prev_store_id").val() != "" && $("#rrd_prev_store_id").val() != $("#rrd_store_id").val()) {
                    if (confirm("Currently the requested location is linked to " + rrd_info.innerText + ". Are you sure you want to unlink it, and instead link it to this new CDM? \nBesides, This CDM is linked to " + $("#rrd_client_name").val() + ", and is Active, are you sure you want to relink it?")) {
                        return true;
                    }
                    return false;
                } else {
                    if (confirm("Currently the requested location is linked to " + rrd_info.innerText + ". Are you sure you want to unlink it, and instead link it to this new CDM?")) {
                        return true;
                    }
                    return false;
                }
            } else {
                if ($("#rrd_prev_store_id").val() != "" && $("#rrd_prev_store_id").val() != $("#rrd_store_id").val()) {
                    if (confirm("This CDM is linked to " + $("#rrd_client_name").val() + ", and is Active, are you sure you want to relink it?")) {
                        return true;
                    }
                    return false;
                }
            }
        });
    }
}

export function LoadPage() {
    InitPage("rrds index", () => {
        const c = new CdmIndex();
    });
}
